 import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import useStateRef from "react-usestateref";

function SelectedCrumbContainer(props) {
  const [screenWidth, setScreenWidth] = useState('')
  const [allBrandsFlag, setAllBrandsFlag, allBrandsFlagRef] = useStateRef('')

  const history = useHistory();

  function handleSearchSubmit(event) {
    event.preventDefault();
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let query_param = params.has("q")
    var field_id = document.getElementById('search_field')
    var value = field_id.value
    if (query_param && params.get("q")) {
      params.set("q", value + "," + params.get("q"))
    } else {
      params.set("q", value)
    }
    params.set("secSearch", true)
    history.push({
      pathname: window.location.pathname,
      search: params.toString(),
      state: {}
    });
  }

  useEffect(() => {
    setScreenWidth(screen.width)
    if (sessionStorage.getItem('allBrandsNavigation')) {
      setAllBrandsFlag(sessionStorage.getItem('allBrandsNavigation'))
    }
  }, [])

  function checkUrl(url) {
    if (url === "/") {
      if (allBrandsFlagRef.current) {
        url = "/all-brands"
      }
    }
    return url
  }

  function handleRemoveAllBrandsUrlFromSession(event) {
    if (sessionStorage.getItem('allBrandsNavigation')) {
      // setAllBrandsFlag('')
      sessionStorage.removeItem('allBrandsNavigation')
    }
  }


  return (
    <div data-cont-id={props.containerObject.contentId} data-zone={props.dataZone} data-page-id={props.contentId} data-template-name={props.templateName} className={`vast-plugin-content row g-0 mx-2 d-lg-block d-none `}>
     
      {props.containerObject && props.containerObject.selectedCrumb && props.containerObject.selectedCrumb.length > 0 ? <>
        <div className="d-lg-block d-none">
          <h3 class="c-sidepanel-heading">Selected Options</h3>
          <div class="c-side-list">
            <ul class="list-group">
              {props.containerObject.selectedCrumb ? props.containerObject.selectedCrumb.map((selectedCrumb) => {
                return (
                  <li class="list-group-item selectedCrumb">
                    <Link to={selectedCrumb.navigationState ? selectedCrumb.navigationState : ""} ><span class="list-selected-item">
                      <strong>{selectedCrumb.displayName ? selectedCrumb.displayName : ""}:&nbsp;</strong> {selectedCrumb.label ? selectedCrumb.label : ""}&nbsp;&nbsp;</span>
                      <span class="c-list-icon c-selected-icon">
                        <i class="bi bi-x"></i>
                      </span>
                    </Link>
                  </li>
                )
              })
                : ""}
            </ul>
          </div>
        </div>
      </> : ""}
    </div>
  );
}

export default SelectedCrumbContainer;
